import { ReferralActions, ReferralStateType } from './refferalTypes';

const referralReducer = (
    state: ReferralStateType,
    action: ReferralActions
): ReferralStateType => {
    switch (action.type) {
        case 'SET_REFERRAL':
            return {
                ...state,
                referral: action.payload,
            };
        default:
            return state;
    }
};

export default referralReducer;
